import { AccordionItemFieldsFragment } from '@src/generated/graphql';
import { useEffect, useRef, useState } from 'react';

type AccordionProps = {
  items: AccordionItemFieldsFragment[];
};

const Accordion = ({ items }: AccordionProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleToggle = (index: number) => {
    setActiveIndex(prevIndex => (prevIndex === index ? 0 : index));
  };

  useEffect(() => {
    contentRefs.current.forEach((ref, i) => {
      if (ref) {
        if (i === activeIndex) {
          ref.style.height = `${ref.scrollHeight}px`; // Open accordion
        } else {
          ref.style.height = '0px'; // Close accordion
        }
      }
    });
  }, [activeIndex]);

  return (
    <div className="accordion">
      {items.map((item, index) => {
        const title = item.itemText ?? '';
        const itemDescription =
          item.itemDescriptionJson?.json?.content?.[0]?.content?.[0]?.value ?? '';

        const isActive = activeIndex === index;

        return (
          <div className={`accordion-item ${isActive ? 'accordion-open' : ''}`} key={index}>
            <div
              className="accordion-header"
              onClick={() => handleToggle(index)}
              role="button"
              tabIndex={0}
              onKeyDown={e => e.key === 'Enter' && handleToggle(index)}
            >
              <span className="accordion-txt">{title}</span>
              {/* <span className={`accordion-icon ${isActive ? 'icon-open' : 'icon-close'}`}></span> */}
            </div>
            <div
              ref={el => {
                contentRefs.current[index] = el;
              }}
              className="accordion-body-streamlined"
              style={{
                overflow: 'hidden',
                transition: 'height 0.3s ease, margin-top 0.3s ease',
                marginTop: '0px',
                height: '0px',
              }}
            >
              <p
                style={{                  
                  marginTop: 10,
                }}
              >
                {itemDescription}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
